import React from 'react';
import styled from 'styled-components';

import css from 'css';

const Html = props => <Wrapper content={props.content ? 'yes' : 'no'} className={props.className} dangerouslySetInnerHTML={{ __html: props.children }} />

export default Html;

const Wrapper = styled.div`
    ${props => props.content ? `
        p {
            font-size:18px;
            margin: 0 0 20px;
            line-height:1.4;
        }
        h1 {
            font-size:43px;
            margin-bottom: 30px;
            font-family: ${css.fonts.bg_bold};
            line-height:50px;
            @media (max-width:480px) {
                font-size: 26px;
                line-height: 31px;
            }
        }
        h2 {
            font-size:40px;
            margin-bottom: 30px;
            font-family: ${css.fonts.bg_bold};
            line-height: 1.2;
        }
        h3 {
            font-size:35px;
            margin-bottom: 30px;
            font-family: ${css.fonts.bg_bold};
            line-height: 1.3;
        }
        h4 {
            font-size:30px;
            margin-bottom: 30px;
            font-family: ${css.fonts.bg_bold};
        }
        h5 {
            font-size:24px;
            margin-bottom: 20px;
            font-family: ${css.fonts.bg_bold};
        }
        h6 {
            font-size:20px;
            margin-bottom: 20px;
            font-family: ${css.fonts.bg_bold};
        }
        blockquote {
            font-family: ${css.fonts.bg_bold};
            font-size:43px;
            line-height: 50px;
            margin: 80px 0;
            @media (max-width:480px) {
                font-size: 26px;
                line-height: 31px;
            }
            p {
                margin: 0;
                font-family: ${css.fonts.bg_bold};
                font-size:43px;
                line-height: 50px;
                @media (max-width:480px) {
                    font-size: 26px;
                    line-height: 31px;
                }
            }

            @media (max-width:768px) {
                font-size:30px;
                line-height: 1.2;
                margin: 30px 0;
            }
        }
        ul {
            padding-left:20px;
            margin-bottom:20px;
            li {
                font-size:18px;
                margin-bottom:10px;
                list-style: disc;
            }
        }
        ol {
            padding-left:20px;
            margin-bottom:20px;
            li {
                font-size:18px;
                margin-bottom:10px;
                list-style: decimal;
            }
        }
    ` : ``}
`


// WEBPACK FOOTER //
// ./src/partials/Html.js